import React from 'react';

const OwnerContactWarning = () => (
  <div className="alert alert-warning p-2 mb-2" role="alert">
    Note: If the owner of the contact&apos;s phone number is not added to a verified texting use case, the message will not be sent.
  </div>
);

export default OwnerContactWarning;
